module.exports = __webpack_public_path__ + "static/media/radio.b0c2a4b2.svg";